import { type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { APP_CONFIG } from '@core/config/app-config.tokens';
import { HTTP_TIMEOUT_MS, SKIP_HTTP_TIMEOUT } from '@core/http/http-context.tokens';
import { timeout } from 'rxjs';

export const requestTimeoutInterceptor: HttpInterceptorFn = (request, next) => {
  const appConfig = inject(APP_CONFIG);

  if (request.context.get(SKIP_HTTP_TIMEOUT)) {
    return next(request);
  }

  const timeoutMs = request.context.get(HTTP_TIMEOUT_MS) ?? appConfig.requestTimeoutMs;

  if (!Number.isFinite(timeoutMs) || timeoutMs <= 0) {
    return next(request);
  }

  return next(request).pipe(timeout(timeoutMs));
};
